import React from 'react';
import { SmallText } from 'ds/components/typography';
import { IDeveloperImage } from 'utils/entities';
import * as Styled from './styled';
import { useScreenBreakpoint } from 'consts/breakpoints';
import useAnchorLink from 'hooks/useAnchorLink';

export const ImageInfo: React.FC<IDeveloperImage> = (props) => {
  const { title, url } = props;
  const isMobile = useScreenBreakpoint() === 1;
  const href = useAnchorLink(url);

  if (!title && !isMobile) return null;

  const content = <SmallText weight={isMobile ? 'normal' : 'medium'}>{title}</SmallText>;

  return (
     <Styled.ImageInfoRoot>
       {href ? (
         <a target="_blank" rel="nofollow" href={href} title={title}>{content}</a>
       ) : content}
    </Styled.ImageInfoRoot>
  );
};
